import { SidebarNavigationMobile } from './SidebarNavigationMobile';

export { SidebarNavigationMobile };
export default SidebarNavigationMobile;
